module.exports = __webpack_public_path__ + "img/blue_032.e6d2762a.png";